import {FormControl} from "@angular/forms";

export enum OrderFormKeys {
    NAME = 'name',
    SURNAME = 'surname',
    EMAIL = 'email',
    PHONE = 'phone',
    NOTE = 'note',
    COST_CENTER = 'costCenter',
    ROOM = 'room',
    SELECTED_DATE = 'selectedDate',
    STREET = 'street',
    CITY = 'city',
    COUNTRY = 'country',
    POSTAL_CODE = 'postalCode',
    NUMBER = 'number',
    PICKUPSTATION = 'pickupStations'
}
export type OrderForm = {
    [OrderFormKeys.NAME]: string;
    [OrderFormKeys.SURNAME]: string;
    [OrderFormKeys.EMAIL]: string;
    [OrderFormKeys.PHONE]: any;
    [OrderFormKeys.NOTE]: string;
    [OrderFormKeys.COST_CENTER]?: string;
    [OrderFormKeys.ROOM]?: string;
    [OrderFormKeys.SELECTED_DATE]: string;
    [OrderFormKeys.STREET]?: string;
    [OrderFormKeys.CITY]?: string;
    [OrderFormKeys.COUNTRY]?: string;
    [OrderFormKeys.POSTAL_CODE]?: string;
    [OrderFormKeys.NUMBER]?: string;
     [OrderFormKeys.PICKUPSTATION]?: string;
};


export type ControlsOf<T> = {
    [K in keyof T]: FormControl<T[K] | null>;
};
